import { useCallback } from 'react';
import { APIClient } from '../../helpers/api_helper';

const api = new APIClient();

export const useApi = () => {
  const get = useCallback((url, params) => {
    return api.get(url, params);
  }, []);

  const post = useCallback((url, data, config) => {
    return api.create(url, data, config);
  }, []);

  const put = useCallback((url, data) => {
    return api.put(url, data);
  }, []);

  const patch = useCallback((url, data) => {
    return api.update(url, data);
  }, []);

  const delete_ = useCallback((url, config) => {
    return api.delete(url, config);
  }, []);

  return { get, post, put, patch, delete: delete_ };
};
